/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_HeadlineInputs */

const et_hero_headline = /** @type {(inputs: Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tõstame su ettevõtte päringuid või oste 90 päevaga.`)
};

const en_hero_headline = /** @type {(inputs: Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We grow your business's inquiries or sales in 90 days.`)
};

/**
* | output |
* | --- |
* | "We grow your business's inquiries or sales in 90 days." |
*
* @param {Hero_HeadlineInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_headline = /** @type {((inputs?: Hero_HeadlineInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_HeadlineInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_headline(inputs)
	return en_hero_headline(inputs)
});